import { MigrationType } from '../types';

import { migration1 } from './migration1';
import { migration2 } from './migration2';
import { migration3 } from './migration3';
import { migration4 } from './migration4';
import { migration5 } from './migration5';
import { migration6 } from './migration6';
import { migration7 } from './migration7';
import { migration8 } from './migration8';
import { migration9 } from './migration9';
import { migration10 } from './migration10';
import { migration11 } from './migration11';
import { migration12 } from './migration12';
import { migration13 } from './migration13';
import { migration14 } from './migration14';
import { migration15 } from './migration15';
import { migration16 } from './migration16';
import { migration17 } from './migration17';
import { migration18 } from './migration18';
import { migration19 } from './migration19';

export const INITIAL_SCHEMA_VERSION = 1;
export const MIGRATIONS_LIST: MigrationType[] = [
  migration1,
  migration2,
  migration3,
  migration4,
  migration5,
  migration6,
  migration7,
  migration8,
  migration9,
  migration10,
  migration11,
  migration12,
  migration13,
  migration14,
  migration15,
  migration16,
  migration17,
  migration18,
  migration19,
];

export const ACTUAL_SCHEMA_VERSION = MIGRATIONS_LIST.at(-1)?.version ?? INITIAL_SCHEMA_VERSION;
